const contactsData = [
    {
        phone: '+38(098)-113-29-27',
    },
    {
        phone: '+38(038)-499-03-33',
    }
]

export default contactsData